import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { LearnerShareOverlayComponent } from '../../features/learner/share/learner-share-overlay.component';
import { SiteFooterComponent } from '../../shared/site-footer/site-footer.component';
import { SiteHeaderComponent } from '../../shared/site-header/site-header.component';
import { ToastContainerComponent } from '../../shared/toast/toast-container.component';
import { AuthSessionService } from '../../core/auth-session.service';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    SiteHeaderComponent,
    SiteFooterComponent,
    LearnerShareOverlayComponent,
    ToastContainerComponent,
  ],
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss',
})
export class PublicLayoutComponent {
  private readonly router = inject(Router);
  protected readonly session = inject(AuthSessionService);

  headerVariant: 'marketing' | 'learner' | 'portal' = 'marketing';

  constructor() {
    this.updateVariant(this.router.url);
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((e) => this.updateVariant(e.urlAfterRedirects));
  }

  private updateVariant(url: string): void {
    if (url.startsWith('/portal') || url.startsWith('/partner/login')) {
      this.headerVariant = 'portal';
      return;
    }
    this.headerVariant =
      url.startsWith('/learner') ||
        url.startsWith('/account') ||
        url.startsWith('/learning') ||
        url.startsWith('/career-challenges') ||
        url.startsWith('/notifications') ||
        url.startsWith('/onboarding') ||
        url.startsWith('/journey') ||
        url.startsWith('/achievements') ||
        url.startsWith('/job-readiness') ||
        url.startsWith('/community')
        ? 'learner'
        : 'marketing';
  }
}
